var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20967)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "url(#paint0_linear_1_20967)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_20967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 12.5H12.5V35.5H35.5V12.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_20967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4399 21.3203C35.2884 20.8546 34.8753 20.5249 34.3886 20.4808L27.7491 19.878L25.1252 13.7349C24.9315 13.2835 24.4907 12.9922 24 12.9922C23.5094 12.9922 23.0684 13.2835 22.8759 13.7349L20.252 19.878L13.6115 20.4808C13.1247 20.5257 12.7125 20.8555 12.5602 21.3203C12.4088 21.786 12.5486 22.2968 12.9168 22.6197L17.9357 27.0206L16.4558 33.5382C16.3476 34.0174 16.5336 34.513 16.9312 34.8004C17.1449 34.9557 17.3961 35.0333 17.648 35.0333C17.8646 35.0333 18.0813 34.9757 18.2749 34.8599L24 31.4367L29.7242 34.8599C30.1441 35.1108 30.6721 35.0879 31.0689 34.8004C31.4665 34.513 31.6525 34.0174 31.5442 33.5382L30.0644 27.0206L35.0833 22.6197C35.4513 22.2968 35.5913 21.7871 35.4399 21.3203Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_20967",
    x1: 10.8692,
    y1: 37.1341,
    x2: 39.1834,
    y2: 8.81995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F42334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7866"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.dffc0e5b4e669d47f7efeba29c8023f8.svg";
export { ForwardRef as ReactComponent };